import styled from 'styled-components';

export const DatePickerStyles = styled.div`
  .popup-content {
    max-width: 760px;
  }

  // Стили для режима "Только просмотр"
  &&.read-only {
    .rdrDayInPreview,
    .rdrDayStartPreview,
    .rdrDayEndPreview {
      display: none;
    }
    .rdrDay {
      cursor: auto;
    }
  }

  // Меняем цвет задизейбленных ячеек
  && .rdrDayDisabled {
    background-color: #f1f1f1;
    color: #8c969d;

    .rdrStartEdge ~ .rdrDayNumber span {
      color: #8c969d;
    }

    // Добавляем зачеркивание задизебленным ячейкам
    .rdrDayNumber span::before {
      content: '';
      position: absolute;
      bottom: 4px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, 0);
      width: 18px;
      height: 1px;
      border-radius: 2px;
      background: #8c969d;
    }
  }

  // Убираем заливку у текущего range если он disabled
  .rdrDayDisabled .rdrEndEdge {
    display: none;
  }

  // Убираем заливку, если еще ничего не жмякали
  &&.init-state .rdrDay:not(.rdrDayDisabled) .rdrStartEdge,
  &&.init-state .rdrDay:not(.rdrDayDisabled) .rdrEndEdge {
    background: none;
    & ~ .rdrDayNumber span {
      color: #1d2429;
    }
  }

  // Меняем цвет подчеркивания текущей даты
  && .rdrDayToday .rdrStartEdge ~ .rdrDayNumber span::after {
    background: #478cc8;
  }

  // Убираем подчеркивание текущей даты, если дата disabled
  && .rdrDayToday.rdrDayDisabled .rdrDayNumber span::after {
    display: none;
  }

  @media (max-width: 420px) {
    .date-picker-container {
      text-align: center;
    }
  }

  @media (max-width: 370px) {
    .rdrMonth {
      width: 23em;
    }
  }
`;

export const DatePickerFooter = styled.div`
  display: flex;
  align-items: center;

  .save-btn {
    margin-right: 16px;
  }

  .clear-btn {
    margin-left: auto;
  }

  @media (max-width: 420px) {
    flex-direction: column;

    .clear-btn {
      order: 0;
      margin-left: 0;
    }

    .save-and-reset-wrapper {
      order: 1;
      margin-top: 15px;
    }
  }
`;

export const SelectedDatesListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;

  .list-title {
    font-size: 12px;
    margin-right: 6px;
  }

  &:not(.read-only) {
    @media (min-width: 647px) {
      min-height: 38px;
    }
  }
`;

export const SelectedDateItemStyles = styled.span`
  display: flex;
  width: min-content;
  white-space: nowrap;
  align-items: center;
  padding: 6px;
  background-color: #f1f1f1;
  border-radius: 4px;
  margin-right: 8px;
  margin-bottom: 8px;

  .text {
    user-select: none;
    font-size: 12px;
  }

  .icon {
    display: flex;
    align-items: center;
    margin-left: 4px;

    &:hover {
      cursor: pointer;
    }
  }
`;
